import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { ReactComponent as IconBell } from '../../assets/images/icons/icon_bell.svg';
import { ReactComponent as IconVet } from '../../assets/images/icons/icon_vet_black.svg';
import { ReactComponent as IconLight } from '../../assets/images/icons/icon_light.svg';
import { ReactComponent as IconBattery } from '../../assets/images/icons/icon_battery_charging.svg';
import { ReactComponent as IconReinforced } from '../../assets/images/icons/icon_reinforced.svg';
import { ReactComponent as IconDrip } from '../../assets/images/icons/icon_drip.svg';
import { ReactComponent as IconTracking } from '../../assets/images/icons/icon_tracking.svg';

const UltraFeatureList = () => {
  const features = [
    {
      icon: <IconTracking />,
      title: 'Lost Dog Mode',
      description: 'Use both GPS & LTE-M to get real-time location updates',
    },
    {
      icon: <IconBell />,
      title: 'Escape Alerts & Virtual Fences',
      description: 'Easily set safe zones and get instant alerts if they stray',
    },
    {
      icon: <IconVet />,
      title: 'AI Vet Records',
      description: "Upload your dog's documents and have them automatically organized",
    },
    {
      icon: <IconDrip />,
      title: 'Fully Waterproof',
      description: 'IP68/66K tested in salt water up to 50 meters',
    },
    {
      icon: <IconLight />,
      title: 'Color Night Light',
      description: 'Keep your dog visible even in the dark',
    },
    {
      icon: <IconReinforced />,
      title: '500lbs+ Resistance',
      description: 'Handles the worst chewers and pullers',
    },
    {
      icon: <IconBattery />,
      title: 'Long Battery Life',
      description: 'Up to 3 months on one charge',
    },
  ];

  return (
    <Box
      p={24}
      sx={{
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        borderRadius: 16,
      }}
    >
      {features.map((item, index) => (
        <Group key={index} spacing={12} align="flex-start" noWrap sx={{ width: '100%' }}>
          <Box
            sx={{
              width: 24,
              height: 24,
              flexShrink: 0,
              svg: { width: '100%', height: '100%' },
            }}
          >
            {item.icon}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Text size={16} weight={600} sx={{ lineHeight: '140%' }}>
              {item.title}
            </Text>
            <Text size={16} weight={500} sx={{ lineHeight: '140%' }}>
              {item.description}
            </Text>
          </Box>
        </Group>
      ))}
    </Box>
  );
};

export default UltraFeatureList;
